import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import byteLockup from '../assets/byte-lockup.png';

/** Shared header for the franchisee-facing pages: brand mark + a sign-out (when authenticated). */
export function FranchiseeHeader() {
  const { user, logout } = useAuth();
  return (
    <header className="sticky top-0 z-30 border-b border-border-subtle bg-white/95 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-3xl items-center justify-between gap-3 px-4">
        <div className="flex min-w-0 items-center gap-3">
          <img src={byteLockup} alt="Byte by Yum!" className="h-6 w-auto sm:h-7" />
          <span aria-hidden="true" className="hidden h-5 w-px bg-border-strong sm:inline-block" />
          <span className="hidden text-[11px] font-semibold uppercase tracking-[0.12em] text-graphite-500 sm:inline">
            Product Adoption
          </span>
        </div>
        {user && (
          <div className="flex min-w-0 items-center gap-2 sm:gap-3">
            <span className="hidden max-w-[32vw] truncate text-sm text-graphite-500 sm:inline">
              {user.franchisee?.name ?? user.email ?? user.username}
            </span>
            <button
              onClick={logout}
              aria-label="Sign out"
              className="flex shrink-0 cursor-pointer items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm text-graphite-600 transition hover:bg-surface-muted"
            >
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
